import { Fragment } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { NavLink } from "react-router-dom";
// import { withStyles } from "@mui/system";

import { List, ListItem } from "@mui/material";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto",
  },
});

function ResultDetails(props) {
  let searchResultDetails = props.searchResultDetails;
  const resultList = searchResultDetails?.map((searchResultDetails, i) => (
    <ListItem key={i}>
      {searchResultDetails ? (
        <Fragment>
          <NavLink
            to={"/domain/search/owner/" + searchResultDetails.id}
            className="Nav_link"
          >
            {searchResultDetails.email}
          </NavLink>
        </Fragment>
      ) : null}
    </ListItem>
  ));

  return (
    <Container maxWidth="lg">
      <Grid container spacing={3}>
        <Grid item xs={12} md={8} lg={5}>
          {searchResultDetails ? <List>{resultList}</List> : null}
        </Grid>
      </Grid>
    </Container>
  );
}

// export default withStyles(styles, { withTheme: true })(ResultDetails);
export default ResultDetails
